import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  DateField,
  EditButton,
  DeleteButton,
  Filter,
  SearchInput,
  SelectInput,
  BooleanInput,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin';

const UserFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" placeholder="Search users..." alwaysOn />
    <SelectInput
      source="role"
      choices={[
        { id: 'ADMIN', name: 'Admin' },
        { id: 'CUSTOMER', name: 'Customer' },
      ]}
      emptyText="All roles"
    />
    <BooleanInput source="isActive" label="Active only" />
  </Filter>
);

const UserListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const UserList: React.FC = () => (
  <List
    filters={<UserFilter />}
    actions={<UserListActions />}
    sort={{ field: 'createdAt', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid rowClick="show">
      <EmailField source="email" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <TextField source="role" />
      <BooleanField source="isActive" />
      <DateField source="createdAt" showTime />
      <EditButton />
      <DeleteButton mutationMode="pessimistic"/>
    </Datagrid>
  </List>
);
